import gql from 'graphql-tag'
import { PaymentMethodFields_source } from './__generated__/PaymentMethodFields'

export const CARD: PaymentMethodFields_source['type'] = 'card'

export const PaymentMethodFieldsFragment = gql`
  fragment PaymentMethodFields on PaymentMethod {
    id
    family {
      id
    }
    source {
      type
      last4
      expYear
      expMonth
      brand
      bankName
    }
  }
`
